import React from 'react';
import { Map, X } from 'lucide-react';
import { Button } from '@common/Button';

const Header = ({ surveyData, showSidebar, setShowSidebar }) => {
  return (
    <div className="bg-[#2A2B2E] p-4 shadow-md z-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div>
            <h1 className="text-xl font-semibold text-white">{surveyData?.name || 'Shared Map'}</h1>
            <p className="text-sm text-gray-400">
              {surveyData?.customerName ? `Customer: ${surveyData.customerName}` : 'Shared Survey'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => setShowSidebar(!showSidebar)}
            className="p-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg"
            title={showSidebar ? 'Hide Sidebar' : 'Show Sidebar'}
          >
            {showSidebar ? <X className="w-5 h-5" /> : <Map className="w-5 h-5" />}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Header;